import React, { useEffect } from 'react'
import { Box, Container, Grid, Typography, } from '@mui/material';
import { Link } from "react-router-dom";
import Divider from '@mui/material/Divider';
import { BoImg, BoMainV } from './CateCs'
import { useState } from 'react';
import axios from 'axios';
import { API_URL, APP_URL } from '../../Config/index';
import LikeButton from "../Like/likebutton";
import notrevealed from '../../images/notrevealed.jpg';

const AllDetails = () => {
    const [nftdata, setnftdata] = useState();

    const fetchallnft = async () => {

        return await axios.get(`${API_URL}/indexData.php?type=All`, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }).then(res => {
            setnftdata(res.data);
        })
    }

    useEffect(() => {
        fetchallnft();
    }, [])

    return (
        <>
            <Box className="explore">
                <Container maxWidth='xl'>
                    <Grid container spacing={1}>
                        {nftdata && nftdata.map((token, index) => (
                            <Grid key={index} item lg={3} sm={6} md={6} xs={12} marginBottom='30px'>
                                <BoMainV className='ContenMain'>

                                    <BoImg>
                                        <Link to={`./Buydetails/${token.NFT_id}`}>
                                            {token.NFT_image.split('.').pop() == "png" || token.NFT_image.split('.').pop() == 'jpg' || token.NFT_image.split('.').pop() == 'jpeg' ?
                                                <img src={token.Private==0? APP_URL + '/' + token.NFT_image:notrevealed} width='100%' className='base_pht' style={{ borderRadius: '5px' }} />
                                                : token.NFT_image.split('.').pop() == "mp4" ?
                                                    <video width="750" height="500" controls >
                                                        <source src={token.Private==0 ? APP_URL + '/' + token.NFT_image:notrevealed} type="video/mp4" />
                                                    </video>
                                                    : token.NFT_image.split('.').pop() == "mp3" || token.NFT_image.split('.').pop() == 'aac' ?
                                                        <audio controls>
                                                            <source src={token.Private==0 ? APP_URL + '/' + token.NFT_image:notrevealed} type="audio/mpeg" />
                                                            Your browser does not support the audio tag.
                                                        </audio>
                                                        : <img src={token.Private==0?APP_URL + '/' + token.NFT_image:notrevealed} width='100%' className='base_pht' style={{ borderRadius: '5px' }} />
                                            }

                                        </Link>
                                    </BoImg>

                                    <Box display='flex' justifyContent='space-between' paddingY='10px'>
                                        <Box>
                                            <Typography fontWeight='600' fontSize='22' variant='h6' color='#000'>
                                                {token.Private==0 ?token.NFT_name:"SECRET NFT"}
                                            </Typography>
                                        </Box>
                                        <Box>
                                            <LikeButton nft={token} color='#000 !important' />
                                        </Box>
                                    </Box>
                                    <Divider />
                                    <Box>
                                        <Box>
                                            <Typography variant='h5' color='#000' fontWeight='600' fontSize='16px'>
                                                Reserve Price
                                            </Typography>
                                            <Typography fontWeight='500' variant='h6' fontSize='15px' color='#000'>
                                                {token.NFT_price} {token.NFT_payment}
                                            </Typography>
                                        </Box>
                                    </Box>
                                </BoMainV>
                            </Grid>
                        ))}
                    </Grid>
                </Container>
            </Box>
        </>
    )
}

export default AllDetails